export const domicilioOcupaciones = [
  {Id: 'F', Nombre: "DE FAMILIARES"},
  {Id: 'H', Nombre: "HIPOTECADA"},
  {Id: 'O', Nombre: "OTRA"},
  {Id: 'P', Nombre: "PROPIA"},
  {Id: 'R', Nombre: "RENTADA"},
]
